// user
export const selectUserData = state => state.user.userData
export const selectPartnerAC = state => state.user.partnerAffiliateCode
export const selectEaid = state => state.user.eaid
export const selectBundleId = state => state.user.bundleId
export const selectEnvConfig = state => state.user.envConfig

// // Actual roles, Dropdown switched role, Flag if user is impersonating/switching
export const selectUserRoles = state => ({
  actualRole: state.userRole.actualRole,
  switchedRole: state.userRole.switchedRole,
  isSwitchRoleUser: state.userRole.isSwitchRoleUser,
})

// Final effective role
export const selectEffectiveRole = state => {
  const {actualRole, switchedRole, isSwitchRoleUser} = state.userRole
  if (isSwitchRoleUser && switchedRole) return switchedRole

  // Return actualRole if defined, else empty array
  return actualRole ?? []
}
